export enum LoadingSize {
  S = 40,
  M = 80,
  L = 120,
}
